import { z } from "zod";

export const DashboardRuntimePayloadSchema = z.object({
	code: z.string().min(1),
	updatedAt: z.string().datetime().optional(),
});

export type DashboardRuntimePayload = z.infer<typeof DashboardRuntimePayloadSchema>;

export type DashboardRuntimeValidationIssue = {
	message: string;
	rule: string;
};

export type DashboardRuntimeValidationResult =
	| {
			issues: DashboardRuntimeValidationIssue[];
			ok: true;
	  }
	| {
			issues: DashboardRuntimeValidationIssue[];
			ok: false;
	  };
